import type { Response } from '~/types/api/v2'

import { useFetchWithDefaults } from '~/composables/api/useFetchWithDefaults'

import type { WorkspaceIdentifier } from '../../types'

export const useFetchDocumentProperties = () => {
  const { post, put, deleteRequest } = useFetchWithDefaults()

  const url = (documentId: string, attributeId: string) => `/v2/documents/${documentId}/properties/${attributeId}/values`

  const create = ({
    workspaceId,
    documentId,
    attributeId,
    payload,
  }: WorkspaceIdentifier & {
    documentId: string
    attributeId: string
    payload: App.Data.Payloads.Documents.Properties.CreatePropertyPayload
  }) => post<Response<
    App.Data.Document.Metadata.StringValueData |
    App.Data.Document.Metadata.NumericValueData |
    App.Data.Document.Metadata.DateValueData
  >>({
    url: url(documentId, attributeId),
    workspaceId,
    fetchOptions: {
      body: payload,
    },
  })

  const update = ({
    workspaceId,
    documentId,
    attributeId,
    valueId,
    payload,
  }: WorkspaceIdentifier & {
    documentId: string
    attributeId: string
    valueId: string
    payload: App.Data.Payloads.Documents.Properties.UpdatePropertyPayload
  }) => put<Response<
    App.Data.Document.Metadata.StringValueData |
    App.Data.Document.Metadata.NumericValueData |
    App.Data.Document.Metadata.DateValueData
  >>({
    url: `${url(documentId, attributeId)}/${valueId}`,
    workspaceId,
    fetchOptions: {
      body: payload,
    },
  })

  const drop = ({
    workspaceId,
    documentId,
    attributeId,
    valueId,
  }: WorkspaceIdentifier & {
    documentId: string
    attributeId: string
    valueId: string
  }) => deleteRequest({
    url: `${url(documentId, attributeId)}/${valueId}`,
    workspaceId,
  })

  return {
    create,
    update,
    drop,
  }
}
